<template>
  <div class="w-full relative" id="eggDescription">

    <title-w-star :title="title" :titleColor="titleColor" :starIconObj="starIconObj" />

    <!-- left/right background star -->
    <div class="mb-14 absolute right-0 bottom-0 -z-10" style="width: 9.5vw"
      v-if="isShowStarBackgroundRight && Object.keys(starBackgroundRightObj).length != 0"
      :style="'top: ' + starBackgroundRightObj.top">

      <img
        :src="commonStore.getImgUrl(starBackgroundRightObj.componentName, starBackgroundRightObj.imgName, starBackgroundRightObj.imgFormat)" />

    </div>
    <div class="absolute left-0 -z-10" style="width: 9.5vw"
      v-if="isShowStarBackgroundLeft && Object.keys(starBackgroundLeftObj).length != 0"
      :style="'bottom: ' + starBackgroundLeftObj.bottom">

      <img
        :src="commonStore.getImgUrl(starBackgroundLeftObj.componentName, starBackgroundLeftObj.imgName, starBackgroundLeftObj.imgFormat)" />

    </div>

    <!-- egg card section -->
    <div class="relative bg-[#F1F2F2] flex items-center mx-10" style="border-radius: 63px; padding: 3vw 4vw">

      <!-- egg image -->
      <div :style="[eggImgObj.position == 'right' ? 'right:5%' : '']" class="absolute" style="width: 18.5vw; top: -10%">

        <div class="image-container">
          <img :src="commonStore.getImgUrl(eggImgObj.componentName, eggImgObj.imgName, eggImgObj.imgFormat)"
            v-if="Object.keys(eggImgObj).length != 0" />

          <slot name="customButtonContent"></slot>
          
        </div>
      </div>

      <div class="text-left font-jost"
        :style="[eggImgObj.position == 'left' ? 'padding-left: 22vw' : 'padding-right: 22vw', 'color:' + descColor, textCustomStyle]"
        :class="[textMode == 'paragraph' ? 'space-y-5' : '', { 'text-2xl': descFontSize == 'big', 'text-lg': descFontSize == 'small' }]">

        <template v-if="textMode == 'text'">

          <div v-if="label" class="font-lora font-bold"
            :class="[labelFontClassSize ? labelFontClassSize : 'text-4xl', description ? 'mb-10' : '']"
            :style="['color:' + labelColor]" v-html="t(label)" />

          <div v-if="description" v-html="t(description)" />

        </template>

        <template v-else v-for="(item, index) in description" :key="index">

          <span v-html="t(item)" v-if="textMode == 'line'" :class="t(item) == '#' ? 'text-base align-top' : ''"></span>
          <div v-html="t(item)" v-if="textMode == 'paragraph'" :class="t(item) == '#' ? 'text-base align-top' : ''"></div>

        </template>

        <slot name="customSection"></slot>

      </div>

    </div>

    <div id="eggDescriptionFooter" class="mx-10 mt-8 text-lg" style="padding-left: 4vw; padding-right: 4vw"
      :class="[footerCustomStyle]" v-if="footer != undefined">

      <template v-if="Array.isArray(footer)">

        <template v-for="(item, index) in footer" :key="'eggDescriptionFooter' + index">
          <div>{{ t(item) }}</div>
        </template>

      </template>

      <template v-else>

        <div v-html="t(footer)" />

      </template>

    </div>

  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "vue";
import { useCommonStore } from "@/stores/common";
import { useI18n } from "vue-i18n";

const commonStore = useCommonStore();
const { t, locale } = useI18n();

onMounted(async () => { });

import { toRefs } from "vue";

const props = defineProps({
  title: {
    type: String,
    default: "",
  },
  titleColor: {
    type: String,
    default: "#494949",
  },
  starIconObj: {
    type: Object,
    default: {},
    //{ componentName: 'telemedicine', imgName: 'starIconLightBlue', imgFormat: 'svg' }
  },
  eggImgObj: {
    type: Object,
    default: {},
    //{ componentName: 'telemedicine', imgName: 'starIconLightBlue', imgFormat: 'svg', position: 'left' }
  },
  isShowStarBackgroundLeft: {
    type: Boolean,
    default: true,
  },
  isShowStarBackgroundRight: {
    type: Boolean,
    default: true,
  },
  starBackgroundLeftObj: {
    type: Object,
    default: {},
    //{ componentName: 'telemedicine', imgName: 'starIconLightBlue', imgFormat: 'svg',top:'20%'   }
  },
  starBackgroundRightObj: {
    type: Object,
    default: {},
    //{ componentName: 'telemedicine', imgName: 'starIconLightBlue', imgFormat: 'svg',bottom:'20%'  }
  },
  textMode: {
    type: String,
    default: "text",
    //text (only one pargraph), line (multiple lines with <span> tag), paragraph (those lines treated as new paragraph)
  },
  label: {
    type: String,
    default: "",
  },
  description: {
    type: [String, Array],
  },
  footer: {
    type: [String, Array],
  },
  labelColor: {
    type: String,
    default: "#4E4E4E",
  },
  labelFontClassSize: {
    type: String,
  },
  descColor: {
    type: String,
    default: "#4E4E4E",
  },
  descFontSize: {
    type: String,
    default: "big",
  },
  textCustomStyle: {
    type: String,
  },
  footerCustomStyle: {
    type: String,
  },
});

const { eggImgObj } = toRefs(props);
if (eggImgObj.value.position == undefined) eggImgObj.value.position = "left";

</script>

<style scoped>
.image-container {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.button {
  position: absolute;
  top: 20%;
  left: 35%;
}
</style>